const Facebook = () => {
    return (
<svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.10547 14.4404V8.17871H0V5.69043H2.10547V3.72168C2.10547 2.68262 2.39714 1.88053 2.98047 1.31543C3.5638 0.732096 4.33854 0.44043 5.30469 0.44043C6.08854 0.44043 6.72656 0.476888 7.21875 0.549805V2.76465H5.90625C5.41406 2.76465 5.07682 2.87402 4.89453 3.09277C4.7487 3.27507 4.67578 3.56673 4.67578 3.96777V5.69043H7L6.67188 8.17871H4.67578V14.4404H2.10547Z" fill="white"/>
</svg>
    )
}

export default Facebook;